import { render } from "./candid-post-graph.vue?vue&type=template&id=1a6d4b1b&lang=true"
import script from "./candid-post-graph.vue?vue&type=script&lang=js"
export * from "./candid-post-graph.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__